import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const ACTIVE_PERSONNEL_URL = `${backendUrl}/api/personnel/non_archived/`;
const NON_ACTIVE_PERSONNEL_URL = `${backendUrl}/api/personnel/archived/`;
const PERSONNEL_URL = `${backendUrl}/api/personnel/`;

class PersonnelService {
	async getAllActivePersonnels() {
		try {
			const response = await axios.get(ACTIVE_PERSONNEL_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	async getAllNonActivePersonnels() {
		try {
			const response = await axios.get(NON_ACTIVE_PERSONNEL_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	async getAllPersonnels() {
		try {
			const response = await axios.get(PERSONNEL_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getPersonnel(id) {
		return axios.get(`${PERSONNEL_URL}${id}/`);
	}

	createPersonnel(data) {
		return axios.post(PERSONNEL_URL, data).catch((error) => {
			console.error('Erreur lors de la création du personnel', error);
			throw error;
		});
	}

	updatePersonnel(id, data) {
		return axios.patch(`${PERSONNEL_URL}${id}/`, data);
	}

	deletePersonnel(id) {
		return axios.delete(`${PERSONNEL_URL}${id}/`);
	}

	getPersonnelOptions() {
		return this.getAllActivePersonnels().then((personnels) => {
			return personnels.map((personnel) => ({
				value: personnel.id,
				label: (personnel.nom + ' ' + personnel.prenom).toUpperCase()
			}));
		});
	}

	async getEnseignantOptions() {
		try {
			const personnels = await this.getAllActivePersonnels();

			return personnels
				.filter((personnel) =>
					personnel.poste.toLowerCase().includes('enseignant')
				)
				.map((personnel) => ({
					value: personnel.id,
					label: `${personnel.nom} ${personnel.prenom}`.toUpperCase()
				}));
		} catch (error) {
			console.error('Error fetching enseignant options:', error);
			throw error; // Re-throwing the error so that you can catch it again where you call this method
		}
	}
}

export default new PersonnelService();
